/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameIcon20Light = forwardRef('ScanFrameIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17 4.75A2.75 2.75 0 0 0 14.25 2H12.5a.5.5 0 0 0 0 1h1.75c.966 0 1.75.784 1.75 1.75V6.5a.5.5 0 0 0 1 0V4.75Z" }),
        React.createElement("path", { d: "M4.75 17A2.75 2.75 0 0 1 2 14.25V12.5a.5.5 0 0 1 1 0v1.75c0 .966.784 1.75 1.75 1.75H6.5a.5.5 0 0 1 0 1H4.75Z" }),
        React.createElement("path", { d: "M14.25 17A2.75 2.75 0 0 0 17 14.25V12.5a.5.5 0 0 0-1 0v1.75A1.75 1.75 0 0 1 14.25 16H12.5a.5.5 0 0 0 0 1h1.75Z" }),
        React.createElement("path", { d: "M4.75 2A2.75 2.75 0 0 0 2 4.75V6.5a.5.5 0 0 0 1 0V4.75C3 3.784 3.784 3 4.75 3H6.5a.5.5 0 0 0 0-1H4.75Z" })));
});
